import { styled } from "@mui/material/styles";
import { ComponentPropsWithoutRef, ComponentType } from "react";
import { MARK_SIZE } from "./constants";

type MarkProps = {
  disabled?: boolean;
  active?: boolean;
};

const Mark: ComponentType<ComponentPropsWithoutRef<"div"> & MarkProps> = styled("div", {
  shouldForwardProp: (prop) => prop !== "active",
})<MarkProps>`
  position: absolute;
  width: ${MARK_SIZE}px;
  height: ${MARK_SIZE}px;
  cursor: ${(props) => (props.disabled ? "disabled" : "pointer")};
  border-radius: 50%;
  background-color: ${(props) =>
    props.active ? props.theme.vars.palette.primary.main : props.theme.vars.palette.grey.A200};
`;

export default Mark;
